import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { FiltroComponent } from '../../filtro.component';

@Component({
  selector: 'sub-filtro-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
  ],
})
export class UsuariosComponent implements OnInit {
  @Input('listaUsuarios') listaUsuarios: any = {};
  @Input('filtroUsuario') filtroUsuario: string[];
  @Input('isEmail') isEmail: boolean = false;
  @Output() filtroUsuarioChange = new EventEmitter<any>();

  todosUsuarios: any[] = [];
  filteredUsuarios: any[] = [];

  constructor(
    private filtroService: FiltroControllerService,
    @Optional() private filtroComp?: FiltroComponent
  ) {}

  ngOnInit(): void {
    this.todosUsuarios = [
      ...this.listaUsuarios?.ativos,
      ...this.listaUsuarios?.inativos,
    ].sort();

    this.filteredUsuarios = this.todosUsuarios;
  }

  onFiltroChange(user) {
    const value = this.isEmail ? user.email : user.id;

    this.filtroUsuario = this.filtroUsuario.includes(value)
      ? this.filtroUsuario.filter((x) => x !== value)
      : [...this.filtroUsuario, value];

    this.filtroUsuarioChange.emit(this.filtroUsuario);

    this.filtroService.updateActiveFilters('users', this.filtroUsuario.length);

    this.filtroComp?.sendFilter(false);
  }

  onBuscaChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const searchValue = input.value.toLowerCase().trim();

    if (searchValue.length > 0)
      this.filteredUsuarios = this.todosUsuarios.filter((usuario) =>
        usuario.nome.toLowerCase().trim().startsWith(searchValue)
      );

    if (searchValue.length == 0) this.filteredUsuarios = this.todosUsuarios;

    this.filtroComp?.sendFilter(false);
  }

  // onRadioClick(event: MouseEvent) {
  //   event.preventDefault();

  //   if (this.filtroUsuario.length == 0) {
  //     this.filtroUsuario = [];
  //     this.filtroUsuarioChange.emit([]);
  //     this.filtroService.updateActiveFilters('users', 0);
  //   }
  // }

  isUsuarioAtivo(user) {
    if (!this.filtroUsuario) {
      return;
    }

    return (
      this.filtroUsuario.includes(user.id) ||
      this.filtroUsuario.includes(user.email)
    );
  }
}
